module.exports = __webpack_public_path__ + "img/noke-mobile.06fd0321.png";